import axios from 'axios'
import urls from '@/urls'

let store = {
  namespaced: true,
  state: {
    user: null
  },
  actions: {
    async SUBMIT_LOGIN ({commit, state}, {username, password}) {
      try {
        let req = await axios.post(urls({route: 'user/login'}), {username, password})
        if (req.status === 200) {
          let data = req.data.data
          commit('LOGIN', data)
          axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
          return data.token
        }
      } catch (e) {
        throw e
      }
    },
    SUBMIT_LOGOUT ({commit, state}) {
      commit('LOGOUT')
      delete axios.defaults.headers.common['Authorization']
    }
  },
  mutations: {
    LOGIN (state, creds) {
      state.user = creds
    },
    LOGOUT (state) {
      state.user = null
    }
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/auth.js